import ReactWarning from "../../../../../content/docs/ui/_react-warning";
import RunProgressDescription from "../../../../../content/docs/ui/descriptions/_run-progress";
import AllowRetryDescription from "../../../../../content/docs/ui/descriptions/_run-progress-allow-retry";
import * as React from 'react';
export default {
  ReactWarning,
  RunProgressDescription,
  AllowRetryDescription,
  React
};